import React, { useState, Component } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { demoRequestSchema, DemoRequestFormData } from '../../lib/validation';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
interface DemoRequestFormProps {
  onSuccess?: () => void;
}
export function DemoRequestForm({
  onSuccess
}: DemoRequestFormProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm<DemoRequestFormData>({
    resolver: zodResolver(demoRequestSchema)
  });
  const onSubmit = async (data: DemoRequestFormData) => {
    setIsSubmitting(true);
    // Format email body
    let emailBody = `D-TECH Solutions Zahtev za demonstraciju\n\n`;
    emailBody += `Ime: ${data.name}\n`;
    emailBody += `Email: ${data.email}\n`;
    emailBody += `Telefon: ${data.phone}\n`;
    emailBody += `Grad: ${data.city}\n`;
    emailBody += `Puna adresa: ${data.fullAddress}\n`;
    emailBody += `Željeni datum: ${data.preferredDate}\n`;
    emailBody += `Vremenski period: ${data.timeWindow}\n`;
    if (data.loadType) {
      emailBody += `Tip tereta: ${data.loadType}\n`;
    }
    if (data.estimatedWeight) {
      emailBody += `Procenjena težina: ${data.estimatedWeight}\n`;
    }
    if (data.notes) {
      emailBody += `\nNapomene:\n${data.notes}\n`;
    }
    // Simulate submission (in production, use actual email service)
    window.location.href = `mailto:info@dtech-solutions.com?subject=Zahtev za demonstraciju&body=${encodeURIComponent(emailBody)}`;
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);
    }, 1000);
  };
  if (submitSuccess) {
    return <div className="text-center py-8" data-id="element-23">
        <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-24">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-25">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-26" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-white mb-2" data-id="element-27">
          Zahtev za demonstraciju primljen!
        </h3>
        <p className="text-gray-300 mb-4" data-id="element-28">
          Hvala vam na interesovanju. Uskoro ćemo vas kontaktirati da potvrdimo
          termin demonstracije.
        </p>
        {onSuccess && <Button variant="primary" size="md" onClick={onSuccess} className="mt-6" data-id="element-29">
            Zatvori
          </Button>}
      </div>;
  }
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 5);
  const minDateString = minDate.toISOString().split('T')[0];
  return <form onSubmit={handleSubmit(onSubmit)} className="space-y-6" data-id="element-30">
      <div className="bg-brand-yellow bg-opacity-10 border-2 border-brand-yellow rounded-industrial p-4 mb-6" data-id="element-31">
        <p className="text-sm text-brand-yellow font-semibold" data-id="element-32">
          Zahtevi za demonstraciju moraju biti podneseni najmanje 5 dana
          unapred.
        </p>
      </div>

      <Input label="Ime i prezime *" type="text" {...register('name')} error={errors.name?.message} placeholder="Vaše ime i prezime" data-id="element-33" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-34">
        <Input label="Email *" type="email" {...register('email')} error={errors.email?.message} placeholder="vas.email@primer.com" data-id="element-35" />

        <Input label="Telefon *" type="tel" {...register('phone')} error={errors.phone?.message} placeholder="+381 60 123 4567" data-id="element-36" />
      </div>

      <Input label="Grad *" type="text" {...register('city')} error={errors.city?.message} placeholder="Vaš grad" data-id="element-37" />

      <Input label="Puna adresa *" type="text" {...register('fullAddress')} error={errors.fullAddress?.message} placeholder="Ulica, broj, poštanski broj" data-id="element-38" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-39">
        <Input label="Željeni datum *" type="date" min={minDateString} {...register('preferredDate')} error={errors.preferredDate?.message} data-id="element-40" />

        <Select label="Vremenski period *" options={[{
        value: '',
        label: 'Izaberite vremenski period'
      }, {
        value: '09:00-12:00',
        label: '09:00 - 12:00'
      }, {
        value: '12:00-15:00',
        label: '12:00 - 15:00'
      }, {
        value: '15:00-18:00',
        label: '15:00 - 18:00'
      }]} {...register('timeWindow')} error={errors.timeWindow?.message} data-id="element-41" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-42">
        <Input label="Tip tereta (opciono)" type="text" {...register('loadType')} error={errors.loadType?.message} placeholder="npr. kutije, oprema" data-id="element-43" />

        <Input label="Procenjena težina (opciono)" type="text" {...register('estimatedWeight')} error={errors.estimatedWeight?.message} placeholder="npr. 150 kg" data-id="element-44" />
      </div>

      <Textarea label="Napomene (opciono)" {...register('notes')} error={errors.notes?.message} placeholder="Posebni zahtevi ili pitanja" rows={4} data-id="element-45" />

      <Button type="submit" variant="primary" size="lg" disabled={isSubmitting} className="w-full" data-id="element-46">
        {isSubmitting ? 'Šaljem...' : 'Zatražite demonstraciju'}
      </Button>
    </form>;
}